import React from 'react';

import { SearchableTable } from '../../common_components/SearchableTable';
import { SvgPlot } from '../../common_components/SvgPlot';
import InnerTabs from '../../common_components/InnerTabs';

export const NormStatisticsTabContent = ({ data }) => {
  return (
    <div className="flex flex-col items-center">
      <h2 className="-mt-2">Wyniki testów normalności zmiennych</h2>
      <SearchableTable
        data={data}
        tableSize={'table-lg'}
        tableFixed={true}
        className={'[&_th:last-child]:w-2/5 mb-0 bg-white'}
        ariaLabel="Tabela z wynikami testów normalności"
        exportFilename="testy_normalnosci"
      />
    </div>
  );
};

export const QqplotTabContent = ({ data }) => {
  return (
    <SvgPlot
      imgBlob={data}
      className={'rounded-lg'}
      alt="Wykres Q-Q plot sprawdzający normalność rozkładu danych"
      exportFilename="qqplot"
    />
  );
};

export const CorelationTabContent = ({ data }) => {
  return (
    <SvgPlot
      imgBlob={data}
      className={'rounded-lg'}
      alt="Macierz korelacji pokazująca zależności między zmiennymi"
      exportFilename="korelacja"
    />
  );
};

export const LineRegressionTabContent = ({
  data,
  isLoading,
  needsData,
  visualizationTab,
  onTabChange,
}) => {
  return (
    <InnerTabs
      isLoading={isLoading}
      needsData={needsData}
      tabs={[
        {
          label: 'Wykres Oceny Modelu',
          content: data['plot'] && (
            <SvgPlot imgBlob={data['plot']} exportFilename="regresja_wykres" />
          ),
          onClick: () => onTabChange('plot'),
          defaultChecked: visualizationTab == 'plot',
        },
        {
          label: 'Metryki Oceny Modelu',
          content: data['metrics'] && (
            <SearchableTable
              data={data['metrics']}
              tableSize={'table-lg'}
              tableFixed={true}
              className={
                '[&_th:first-child]:w-1/3 [&_th]:whitespace-normal [&_th:not(:first-child)]:text-center [&_td:not(:first-child)]:text-center  [&_th]:align-top'
              }
              ariaLabel="Tabela metryk oceny modelu z przewijaniem"
              exportFilename="regresja_metryki"
            />
          ),
          onClick: () => onTabChange('metrics'),
          defaultChecked: visualizationTab == 'metrics',
        },
        {
          label: 'Testy Założeń Modelu',
          content: data['assumptionTests'] && (
            <SearchableTable
              data={data['assumptionTests']}
              ariaLabel="Tabela testów założeń modelu z przewijaniem"
              exportFilename="regresja_testy_zalozen"
            />
          ),
          onClick: () => onTabChange('assumptionTests'),
          defaultChecked: visualizationTab == 'assumptionTests',
        },
        {
          label: 'Parametry Modelu',
          content: data['evaluation'] && (
            <SearchableTable
              data={data['evaluation']}
              tableSize={'table-lg'}
              ariaLabel="Tabela parametrów modelu z przewijaniem"
              exportFilename="regresja_parametry"
            />
          ),
          onClick: () => onTabChange('evaluation'),
          defaultChecked: visualizationTab == 'evaluation',
        },
      ]}
    ></InnerTabs>
  );
};
